// extracted by mini-css-extract-plugin
export default {"Base":"Button__Base___KkUZ8W5A","PlayButton":"Button__PlayButton___El0XxSYr"};